export const currencyWithPrefix = (value: number) => {
    const formattedValue = new Intl.NumberFormat('pt-BR', {
        style: 'currency',
        currency: 'BRL'
    }).format(value);

    return formattedValue;
};

export const concurrencyWithoutPrefix = (value: number) => {
    const formattedValue = currencyWithPrefix(value);
    return formattedValue.replace(/^R\$\s?/, '');
}

export const currencyToNumber = (value: string) => {
    if (!value) return 0;

    const numericString = value.replace(/[^\d,-]/g, '').replace('.', '').replace(/,/g, '.');
    const numberValue = parseFloat(numericString);

    return isNaN(numberValue) ? 0 : numberValue;
}